<template>
  <div class="page">
    <div class="topif2">
      <img src="../../assets/images/checkisok.png" alt="" v-if="xiezuozuzt == 'tg'" />
      <img src="../../assets/images/checkisno.png" alt="" v-else-if="xiezuozuzt == 'jj'" />
      <div class="toptext" v-if="xiezuozuzt == 'tg'">审批通过</div>
      <div class="toptext" v-else-if="xiezuozuzt == 'jj'">申请拒绝</div>
    </div>
    <div class="main">
      <div class="mainrow">
        <div v-if="xiezuozuzt == 'tg'">
          <div class="rowrow">
            <div class="rowname">ACMED-新媒体协作组</div>
          </div>
        </div>
        <div v-else-if="xiezuozuzt == 'jj'">
          <div class="rowrow">
            <div class="rowname">ACMED-新媒体协作组</div>
            <div class="rowjj">拒绝理由：{{ list.CheckInformation }}</div>
          </div>
        </div>
      </div>

      <div class="oktogroup" v-if="xiezuozuzt == 'jj'">
        <button class="sqbtn" @click="togrouplist()">重新申请</button>
      </div>
      <div class="qrcode">
        <img src="../../assets/images/acmedXSZS.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { groupBy } from "core-js/fn/map";
import { Dialog } from "vant";
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  name: "mine",
  data() {
    return {
      xiezuozuzt: '获取中',
      type: 0,
      list: [],
      choise: 0,
    };
  },
  created() {
    this.$store.commit("changeNavbarIndex", 3);
    this.getGroup();
    document.title = "华肤荟";
  },
  methods: {
    getGroup() {
      let that = this;
      this.$axios.post('/api/api/web/Customer/GetCollaborativeGroupMediaCustomerCheckStatus').then(res => {
        const status = res.Data;
        that.list = res.Data;
        // console.log('123123')
        if (status.CheckStatus === 20) {
          that.xiezuozuzt = 'tg';
          that.choise = 0
        } else if (status.CheckStatus === 30) {
          that.xiezuozuzt = 'jj';
          that.choise = 1
        }
      });
      // console.log('协作组状态' + that.xiezuozuzt)
    },
    togrouplist() {
      let that = this
      this.$axios.post('/api/api/web/Customer/BindCollaborativeGroupMediaCustomer').then(res => {
        Dialog.alert({
          message: "申请已提交，请等待审批结果",
        }).then(() => {
          // on close
          this.$router.replace('/mine')
        });
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  background: rgb(247, 248, 252);
  width: 100%;
  height: 100%;
  // padding-bottom: 2rem;
}

.topif2 {
  text-align: center;
  padding-top: 0.5rem;

  img {
    width: 15%;
    margin-bottom: .3rem;
  }
}

.toptext {
  font-weight: bold;
  color: #0c2941;
}

.main {
  // margin-top: .5rem;
}

.mainrow {
  width: 80%;
  margin: auto;
  font-weight: bold;
  color: #0c2941;
}

.mainrow1 {
  width: 80%;
  margin: auto;
  padding-top: .5rem;
  font-weight: bold;
  color: #0c2941;
}

.rowrow {
  padding: .5rem 0;
  border-bottom: 1px dashed #c1c1c1;
}

.rowname {
  font-size: .45rem;
}

.rowjj {
  margin-top: .2rem;
}

.rowrow1 {
  padding: .5rem 0;
  border-bottom: 1px dashed #c1c1c1;
}

.rowrow1in {
  display: flex;
  flex-direction: row;
}

.inleft {
  width: 20%;

  img {
    width: 72%;
  }
}

.inright {
  width: 80%;
}

.rowstat {
  font-weight: bold;
}

.oktogroup {
  margin-top: .5rem;
}

.sqbtn {
  display: block;
  border: 0;
  padding: 0.2rem 1rem;
  margin: auto;
  border-radius: 3rem;
  color: #fff;
  background: #2B3764;
}

.qrcode {
  margin-top: 1.5rem;

  img {
    width: 50%;
    display: block;
    margin: auto;
  }
}
</style>